import { createAsyncActionTypes } from '../utils';

export const GET_REQUESTS = createAsyncActionTypes('GET_REQUESTS');
export const UPDATE_REQUEST = createAsyncActionTypes('UPDATE_REQUEST');
export const UPDATE_REQUEST_STATUS = createAsyncActionTypes('UPDATE_REQUEST_STATUS');
